// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__31ezE","author":"Table_author__2qXso","authorImage":"Table_authorImage__3wbvp","unreadRow":"Table_unreadRow__rtu1-"};